import { v4 as uuidv4 } from 'uuid';

export const setRefValue = (refValue: string) => {
  sessionStorage.setItem('refValue', refValue);
};

export const setSiteAccessToken = (siteAccessToken: string) => {
  localStorage.setItem('siteAccessToken', siteAccessToken);
};

export const setIsUserOnboarded = (isOnboarded: string) => {
  localStorage.setItem('isOnboarded', isOnboarded);
};

export const setUserName = (username: string) => {
  localStorage.setItem('username', username);
};

export const setSessionID = (id: string) => {
  localStorage.setItem('sessionID', id);
};

export const setRedirectAfterLogin = (screen: string) => {
  sessionStorage.setItem('screen', screen);
};

export const getRefValue = () => sessionStorage.getItem('refValue');

export const getSessionID = () => localStorage.getItem('sessionID');

export const getSiteAccessToken = () => localStorage.getItem('siteAccessToken');

export const getIsUserOnboarded = () => localStorage.getItem('isOnboarded');

export const getUserName = () => localStorage.getItem('username');

export const getRedirectAfterLogin = () => sessionStorage.getItem('screen');

export const clearRedirectAfterLogin = () => sessionStorage.setItem('screen', '');

export const clearAccessToken = () => {
  localStorage.setItem('siteAccessToken', '');
  localStorage.setItem('username', '');
  localStorage.setItem('isOnboarded', '');
};

export const setDonationSelections = (donationSelections: string) => {
  sessionStorage.setItem('donationSelections', donationSelections);
};

export const getDonationSelections = () => sessionStorage.getItem('donationSelections');

export const clearDonationSelections = () => {
  sessionStorage.removeItem('donationSelections');
};

export const setEventPageSelections = (eventPageSelections: string) => {
  sessionStorage.setItem('eventPageSelections', eventPageSelections);
};

export const getEventPageSelections = () => sessionStorage.getItem('eventPageSelections');

export const clearEventPageSelections = () => {
  sessionStorage.removeItem('eventPageSelections');
};

export const getCheckoutIdempotencyKey = () => localStorage.getItem('checkoutIdempotencyKey');

export const setCheckoutIdempotencyKey = (idempotencyKey: string) => {
  localStorage.setItem('checkoutIdempotencyKey', idempotencyKey);
};

export const clearCheckoutIdempotencyKey = () => {
  localStorage.removeItem('checkoutIdempotencyKey');
};

const GUEST_CART_OWNER_TOKEN_KEY = 'guestCartOwnerToken';
let inMemoryGuestCartOwnerToken: string | undefined;

/**
 * Proves this browser owns its guest carts. It's a credential: never send it to analytics, logs,
 * URLs or third parties, and don't clear it on logout (a cart built before login is found by it).
 *
 * Must be a random v4 uuid: the API ignores anything else. `uuid` falls back to getRandomValues
 * where `crypto.randomUUID` is missing (older Safari, non-secure contexts).
 */
export const getGuestCartOwnerToken = (): string => {
  try {
    const stored = localStorage.getItem(GUEST_CART_OWNER_TOKEN_KEY);
    if (stored) return stored;
    const token = uuidv4();
    localStorage.setItem(GUEST_CART_OWNER_TOKEN_KEY, token);
    return token;
  } catch {
    // Storage is blocked - fall through to a token for this page load only.
  }
  inMemoryGuestCartOwnerToken ??= uuidv4();
  return inMemoryGuestCartOwnerToken;
};
